import { Link, useNavigate } from 'react-router-dom';

/**
 * DetailPageHeader — standard top-of-page header for admin detail screens
 * (Phase 5d-1 follow-up — operator-requested standard pattern).
 *
 *   [← Back to <parent>] ........................................... [×]
 *
 * Left zone: contextual back link (always present — tells the operator where
 * they'll return to). Right zone: [×] universal close button (collapses to
 * backTo by default; pass onClose to override e.g. for unsaved-changes
 * confirmation).
 *
 * Applied to Brief detail in Phase 5d-1 follow-up; queued for retrofit on
 * Customer Detail + Domain Detail in the next polish pass so the pattern is
 * consistent everywhere a staff member opens a sub-record.
 */
export interface DetailPageHeaderProps {
  backTo: string;
  backLabel: string;
  onClose?: () => void;
}

export function DetailPageHeader({ backTo, backLabel, onClose }: DetailPageHeaderProps) {
  const navigate = useNavigate();
  const handleClose = onClose ?? (() => navigate(backTo));
  return (
    <header className="portal-detail-header">
      <Link to={backTo} className="portal-detail-header-back">
        ← {backLabel}
      </Link>
      <button
        type="button"
        className="portal-detail-header-close"
        onClick={handleClose}
        aria-label="Close and return to list"
      >
        <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
          <line x1="3" y1="3" x2="13" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <line x1="13" y1="3" x2="3" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>
    </header>
  );
}
